import ButtonOrLink from '@/atoms/ButtonOrLink/ButtonOrLink';
import clx from 'classnames';
import { useTranslation } from 'react-i18next';
import { TabItemType } from '../TabItem/types';

type Props = {
  item: TabItemType<string>;
  isActive: boolean;
  shallowRouting?: boolean;
};

const BigTagItem = ({ item, isActive, shallowRouting }: Props) => {
  const { t } = useTranslation();
  const { className, icon, label, layout = 'vertical', ...itemRest } = item;

  return (
    <li className="grow">
      <ButtonOrLink
        {...itemRest}
        className={clx(
          'sm-bold-caps font-sans transition flex items-center rounded-md gap-2 w-full',
          layout === 'horizontal' ? 'flex-row p-2' : 'flex-col p-3',
          isActive ? 'text-neutral-50 bg-mercury-900' : 'text-neutral-500',
          className,
        )}
        shallow={shallowRouting}
        type="button"
      >
        {icon && <i className={clx('text-xl', icon)} />}
        <span>{t(label)}</span>
      </ButtonOrLink>
    </li>
  );
};

export default BigTagItem;
